import * as React from "react"
const StarStruck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 246 246"
    {...props}
  >
    <g clipPath="url(#a)">
      <g filter="url(#b)">
        <path
          fill="url(#c)"
          d="M0 115C0 51.487 51.487 0 115 0h12c65.722 0 119 53.278 119 119v8c0 65.722-53.278 119-119 119h-4C55.069 246 0 190.931 0 123v-8Z"
        />
      </g>
      <mask
        id="e"
        width={144}
        height={74}
        x={51}
        y={137}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path
          fill="url(#d)"
          d="M72.2 137.5c-5.607 0-8.411 0-11.553 1.42-4.265 1.927-8.808 8.19-9.316 12.843-.374 3.427.184 5.136 1.3 8.554a73.5 73.5 0 0 0 140.174-1.383c1.041-3.412 1.561-5.117 1.165-8.29-.543-4.355-4.761-10.051-8.768-11.84-2.919-1.304-5.597-1.304-10.952-1.304H72.2Z"
        />
      </mask>
      <g mask="url(#e)">
        <g filter="url(#f)">
          <path
            fill="url(#g)"
            d="M72.2 137.5c-5.607 0-8.411 0-11.553 1.42-4.265 1.927-8.808 8.19-9.316 12.843-.374 3.427.184 5.136 1.3 8.554a73.5 73.5 0 0 0 140.174-1.383c1.041-3.412 1.561-5.117 1.165-8.29-.543-4.355-4.761-10.051-8.768-11.84-2.919-1.304-5.597-1.304-10.952-1.304H72.2Z"
          />
        </g>
        <g filter="url(#h)">
          <path
            fill="#fff"
            d="M51.459 141.68c-2.782-6.378 1.7-13.68 8.658-13.68h123.654c1.509 0-2.262 0-1.243.177 4.734.822 10.863 11.312 9.255 15.839-.346.975 4.792-8.143 2.737-4.496-2.609 4.629-3.002 12.48-8.316 12.48H55.862c-3.855 0-2.862-6.787-4.403-10.32Z"
          />
        </g>
        <g filter="url(#i)">
          <ellipse cx={122} cy={197} fill="url(#j)" rx={29} ry={23} />
        </g>
      </g>
      <g filter="url(#k)">
        <g clipPath="url(#l)">
          <g filter="url(#m)">
            <path
              fill="#FB2EFF"
              d="m113.477 59.509-19.903-2.724a25 25 0 0 1-18.756-13.167l-8.624-16.461a3.984 3.984 0 0 0-1.866-1.757c-2.034-.945-4.505-.158-5.521 1.757l-8.625 16.461a25 25 0 0 1-18.755 13.167L11.523 59.51c-.9.12-1.724.52-2.355 1.126A3.766 3.766 0 0 0 8 63.395a3.778 3.778 0 0 0 1.246 2.73l13.478 12.372a25 25 0 0 1 7.69 22.9l-3.112 17.072a3.66 3.66 0 0 0 .242 2.116c.289.67.771 1.251 1.393 1.676a4.269 4.269 0 0 0 2.124.729c.766.052 1.533-.1 2.212-.438l18.137-8.977a24.997 24.997 0 0 1 22.18 0l18.137 8.977c.798.4 1.725.533 2.613.388 2.24-.364 3.745-2.363 3.359-4.471l-3.112-17.072a25 25 0 0 1 7.689-22.9l13.479-12.373a3.8 3.8 0 0 0 1.197-2.217c.347-2.12-1.223-4.083-3.475-4.398Z"
            />
          </g>
          <g filter="url(#n)">
            <ellipse
              cx={14.5}
              cy={25.634}
              fill="#fff"
              fillOpacity={0.81}
              rx={14.5}
              ry={25.634}
              transform="matrix(.8763 .48176 -.56237 .82689 80.22 55.447)"
            />
          </g>
        </g>
        <g clipPath="url(#o)">
          <g filter="url(#p)">
            <path
              fill="#FB2EFF"
              d="m235.477 59.509-19.903-2.724a25 25 0 0 1-18.756-13.167l-8.624-16.461a3.983 3.983 0 0 0-1.866-1.757c-2.034-.945-4.505-.158-5.521 1.757l-8.625 16.461a24.997 24.997 0 0 1-18.755 13.167l-19.903 2.724a4.21 4.21 0 0 0-2.356 1.126 3.769 3.769 0 0 0-1.168 2.76 3.78 3.78 0 0 0 1.246 2.73l13.478 12.372a24.998 24.998 0 0 1 7.689 22.9l-3.111 17.072a3.66 3.66 0 0 0 .242 2.116c.289.67.771 1.251 1.393 1.676a4.272 4.272 0 0 0 2.124.729c.766.052 1.533-.1 2.212-.438l18.137-8.977a24.997 24.997 0 0 1 22.181 0l18.136 8.977c.798.4 1.725.533 2.613.388 2.239-.364 3.745-2.363 3.359-4.471l-3.112-17.072a25 25 0 0 1 7.689-22.9l13.479-12.373a3.8 3.8 0 0 0 1.197-2.217c.347-2.12-1.223-4.083-3.475-4.398Z"
            />
          </g>
          <g filter="url(#q)">
            <ellipse
              cx={14.5}
              cy={25.634}
              fill="#fff"
              fillOpacity={0.81}
              rx={14.5}
              ry={25.634}
              transform="matrix(.8763 .48176 -.56237 .82689 202.219 55.447)"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="b"
        width={278}
        height={326}
        x={-11}
        y={-24}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius={8}
          result="effect1_innerShadow_397_2929"
        />
        <feOffset dx={21} dy={73} />
        <feGaussianBlur stdDeviation={24} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.682806 0 0 0 0 0.0652778 0 0 0 0 0.783333 0 0 0 0.14 0" />
        <feBlend in2="shape" result="effect1_innerShadow_397_2929" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-24} />
        <feGaussianBlur stdDeviation={15.5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.943639 0 0 0 0 0.223611 0 0 0 0 0.958333 0 0 0 0.44 0" />
        <feBlend
          in2="effect1_innerShadow_397_2929"
          result="effect2_innerShadow_397_2929"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-11} dy={30} />
        <feGaussianBlur stdDeviation={15.5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.766722 0 0 0 0 0.693056 0 0 0 0.68 0" />
        <feBlend
          in2="effect2_innerShadow_397_2929"
          result="effect3_innerShadow_397_2929"
        />
      </filter>
      <filter
        id="f"
        width={142.887}
        height={77.5}
        x={51.215}
        y={137.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="shape" result="effect1_innerShadow_397_2929" />
      </filter>
      <filter
        id="h"
        width={144.384}
        height={27}
        x={50.623}
        y={125}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-3} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.47 0" />
        <feBlend in2="shape" result="effect1_innerShadow_397_2929" />
      </filter>
      <filter
        id="i"
        width={61}
        height={60}
        x={90}
        y={164}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="shape" result="effect1_innerShadow_397_2929" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-3} dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.29 0" />
        <feBlend
          in2="effect1_innerShadow_397_2929"
          result="effect2_innerShadow_397_2929"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-10} />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.828932 0 0 0 0 0.0596354 0 0 0 0 0.954167 0 0 0 0.6 0" />
        <feBlend
          in2="effect2_innerShadow_397_2929"
          result="effect3_innerShadow_397_2929"
        />
      </filter>
      <filter
        id="k"
        width={249}
        height={117}
        x={-1}
        y={25}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={4.5} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.141667 0 0 0 0 0.914166 0 0 0 0.26 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_397_2929"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_397_2929"
          result="shape"
        />
      </filter>
      <filter
        id="m"
        width={111}
        height={110}
        x={6}
        y={19}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-2} dy={-6} />
        <feGaussianBlur stdDeviation={8.5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.991667 0 0 0 0 0.111562 0 0 0 0 0.639625 0 0 0 0.83 0" />
        <feBlend in2="shape" result="effect1_innerShadow_397_2929" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-2} dy={6} />
        <feGaussianBlur stdDeviation={6.5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend
          in2="effect1_innerShadow_397_2929"
          result="effect2_innerShadow_397_2929"
        />
      </filter>
      <filter
        id="n"
        width={102.433}
        height={108.647}
        x={27.294}
        y={29.305}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_397_2929"
          stdDeviation={16}
        />
      </filter>
      <filter
        id="p"
        width={111}
        height={110}
        x={128}
        y={19}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-2} dy={-6} />
        <feGaussianBlur stdDeviation={8.5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.991667 0 0 0 0 0.111562 0 0 0 0 0.639625 0 0 0 0.83 0" />
        <feBlend in2="shape" result="effect1_innerShadow_397_2929" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-2} dy={6} />
        <feGaussianBlur stdDeviation={6.5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend
          in2="effect1_innerShadow_397_2929"
          result="effect2_innerShadow_397_2929"
        />
      </filter>
      <filter
        id="q"
        width={102.433}
        height={108.647}
        x={149.294}
        y={29.305}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_397_2929"
          stdDeviation={16}
        />
      </filter>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h246v246H0z" />
      </clipPath>
      <clipPath id="l">
        <path fill="#fff" d="M8 25h109v98H8z" />
      </clipPath>
      <clipPath id="o">
        <path fill="#fff" d="M130 25h109v98H130z" />
      </clipPath>
      <radialGradient
        id="c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(86.517 45.998 65.918) scale(230.426)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.576} stopColor="#FFBB0C" />
        <stop offset={1} stopColor="#FFC907" />
      </radialGradient>
      <radialGradient
        id="j"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(88.983 -31.053 151.819) scale(39.8355 50.2216)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FC4141" />
        <stop offset={1} stopColor="#FF0F0F" />
      </radialGradient>
      <linearGradient
        id="d"
        x1={122.5}
        x2={107.5}
        y1={211}
        y2={125}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB39A2" />
        <stop offset={1} stopColor="#C520FF" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={122.5}
        x2={77.5}
        y1={211}
        y2={116}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A2EC0" />
        <stop offset={1} stopColor="#FF20C1" />
      </linearGradient>
    </defs>
  </svg>
)
export default StarStruck
